import 'primeicons/primeicons.css'
import styled from 'styled-components'
import { color } from '../../../GlobalStyle'

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
export const Button = styled.button`
  position: relative;
  color: ${color.brand};
  border: 1px solid ${color.brand};
  border: 1px solid ${(props) => props.color};
  color: ${(props) => props.color};

  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  border-radius: 360px;
  margin-left: 0.3rem;
  align-items: center;
  font-size: 15px;
`
export const Item = styled.tr``
export const Sessions = styled.div`
  display: flex;
  justify-content: space-between;
`
export const Session = styled.div`
  display: flex;
  align-items: center;

  button {
    display: flex;
    font-size: 15px;
  }
`

export const Table = styled.table`
  width: 100%;
  border-spacing: 0px;

  tr,
  th,
  td {
    text-align: start;
    border: 1px solid #dee2e6;
    border-width: 0 0 1px 0;
    
  td,
  th {
    padding: 16px 1vw;
  }
`

export const THead = styled.thead`
  background-color: ${({ theme }) => theme.background_secundary};
`

export const Expandable = styled.button`
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
`
export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 4px 0px;
`
export const ContainerTable = styled.div`
  padding: 10px;
`

export const HeaderButton = styled.button`
  padding: 0px 10px;
  font-size: 15px;
`
export const FunctionsButton = styled.div`
  display: flex;
  gap: 4px;
`
